import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

const HEADER_HEIGHT = 48;
const SIDE_PADDING = 8;
const MAX_HEIGHT = 763;
const DEFAULT_WIDTH = 480;
const INFINITY_WIDTH = 430;

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderGray60,
      maxWidth: DEFAULT_WIDTH,
      zIndex: theme.zIndex.modal,
      height: '100%',
      maxHeight: `min(100% - ${SIDE_PADDING * 2}px, ${MAX_HEIGHT}px)`,
      overflowY: 'hidden',
      boxShadow: theme.shape.boxShadowExtraLarge,
      '&$isInfinityMode': {
        width: INFINITY_WIDTH,
      },
    },
    isInfinityMode: {},
    backdrop: {
      zIndex: theme.zIndex.modal - 1,
    },
    header: {
      padding: theme.spacing(1, 2),
      display: 'flex',
      columnGap: theme.spacing(2),
      borderBottom: theme.shape.borderGray70,
      alignItems: 'center',
      height: HEADER_HEIGHT,
    },
    buttonClose: {
      cursor: 'pointer',
      color: COLORS.gray.gray40,
      marginLeft: 'auto',
      fontSize: theme.typography.pxToRem(16),
    },
    toneOfVoiceList: {
      overflowY: 'auto',
      maxHeight: `calc(100% - ${HEADER_HEIGHT}px)`,
    },
  }),
  { name: 'ToneOfVoiceMenu' }
);
